import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.PAYMENT_METHODS]: {
    [ROLE.SWITCH]: [ELEMENT.CASHBACK, ELEMENT.CREDIT],
    [ROLE.RADIO]: [
      ELEMENT.NEW_CREDIT_CARD,
      ELEMENT.EXISTING_CREDIT_CARD,
      ELEMENT.PIX,
      ELEMENT.SLIP,
      ELEMENT.CARNE_DIGITAL,
      ELEMENT.CARD_SLIP,
      ELEMENT.TWO_CARDS,
      ELEMENT.NUBANK,
      ELEMENT.CREDIT_POS,
      ELEMENT.DEBIT_POS,
      ELEMENT.TWO_CREDIT_POS,
      ELEMENT.TWO_DEBIT_POS,
      ELEMENT.CREDIT_DEBIT_POS,
    ],
    [ROLE.TEXT]: [ELEMENT.CASHBACK, ELEMENT.CREDIT, ELEMENT.DISCOUNT],
    [ROLE.BUTTON]: [ELEMENT.CONTINUE],
  },
  [CONTEXT.PAYMENT_REVIEW]: {
    [ROLE.BUTTON]: [ELEMENT.CHANGE_ADDRESS, ELEMENT.CHANGE_PAYMENT],
    [ROLE.TEXT]: [ELEMENT.ADDRESS, ELEMENT.NAME, ELEMENT.PAYMENT_METHOD, ELEMENT.PRICE],
  },
  [CONTEXT.PAYMENT_SUMMARY]: {
    [ROLE.TEXT]: [ELEMENT.CASHBACK, ELEMENT.CREDIT, ELEMENT.PAYMENT_METHOD],
    [ROLE.BUTTON]: [ELEMENT.SUBMIT],
  },
  [CONTEXT.PAYMENT_NUBANK]: {
    [ROLE.BUTTON]: [ELEMENT.CONTINUE],
  },
  [CONTEXT.PAYMENT_CARD]: {
    [ROLE.BUTTON]: [ELEMENT.CONTINUE, ELEMENT.GO_BACK, ELEMENT.SUBMIT],
    [ROLE.FORM]: [ELEMENT.CARD],
    [ROLE.CHECKBOX]: [ELEMENT.SAVE],
    [ROLE.RADIO]: [ELEMENT.INSTALLMENT],
    [ROLE.TEXTBOX]: [ELEMENT.CARD_NUMBER, ELEMENT.CARD_HOLDER, ELEMENT.CARD_DATE, ELEMENT.CARD_CVV],
    [ROLE.TEXT]: [
      ELEMENT.CARD_INFO,
      ELEMENT.CARD_NUMBER,
      ELEMENT.CARD_HOLDER,
      ELEMENT.CARD_DATE,
      ELEMENT.CARD_CVV,
      ELEMENT.INSTALLMENT,
    ],
  },
  [CONTEXT.PAYMENT_CDC]: {
    [ROLE.CHECKBOX]: [ELEMENT.DOWN_PAYMENT, ELEMENT.INSTALLMENT],
    [ROLE.TEXT]: [ELEMENT.DOWN_PAYMENT, ELEMENT.INSTALLMENT, ELEMENT.INTEREST],
    [ROLE.BUTTON]: [ELEMENT.REQUEST, ELEMENT.CONTINUE, ELEMENT.GO_BACK, ELEMENT.CHANGE_PAYMENT],
  },
  [CONTEXT.PAYMENT_COMPOSITE]: {
    [ROLE.TEXTBOX]: [ELEMENT.VALUE, ELEMENT.REMAINING],
    [ROLE.BUTTON]: [ELEMENT.CHANGE_CARD, ELEMENT.CONTINUE, ELEMENT.GO_BACK],
  },
  [CONTEXT.PAYMENT_POS]: {
    [ROLE.RADIO]: [ELEMENT.POS_TERMINAL],
    [ROLE.BUTTON]: [ELEMENT.CONTINUE, ELEMENT.GO_BACK, ELEMENT.SEARCH],
  },
} as TValidTestId;
